<template>
  <div class="animated fadeIn">
    <b-card>
      <template v-slot:header>
        <h5>Input Voucher</h5>
      </template>
      <b-form @submit.prevent="openModalConfirm">
        <div class="form-content-wrapper">
          <b-form-group label="Nama Voucher">
            <b-form-input v-model="input.name" type="text" required />
          </b-form-group>

          <b-form-group label="Tipe Voucher">
            <b-form-select
              v-model="input.type"
              :options="optionType"
              value-field="id"
              text-field="name"
              required
            >
              <template v-slot:first>
                <b-form-select-option :value="null" disabled>Pilih Tipe</b-form-select-option>
              </template>
            </b-form-select>
          </b-form-group>

          <b-form-group label="Harga Voucher (Poin)">
            <b-form-input v-model.number="input.price" type="number" required />
          </b-form-group>

          <b-form-group label="Masa Berlaku (hari)">
            <b-form-input v-model.number="input.expiryDay" type="number" required />
            <small class="form-text text-muted">
                Jika nasabah membeli voucher di tgl 1 Mei dan masa berlaku 15 hari, maka voucher yang dibeli akan expired di 16 Mei
            </small>
          </b-form-group>

          <div v-if="input.type == 1">
          <b-form-group label="Diskon (%)">
            <b-form-input v-model.number="input.discount" type="number" required />
          </b-form-group>

          <b-form-group label="Maximum (Rp)">
            <b-form-input 
            type="text"
            v-model="formattedMaximum"
            required/>
          </b-form-group>
          </div>

          <b-form-group label="Deskripsi Voucher">
            <b-form-textarea v-model="input.description" rows="3" required />
          </b-form-group>

          <b-form-group label="Syarat & Ketentuan Voucher">
            <b-form-textarea v-model="input.policy" rows="3" required />
          </b-form-group>
        <b-form-group label="Upload Gambar Voucher">
        <b-form-file
            v-model="input.file"
            accept="image/*"
            :state="Boolean(input.file)"
            @change="previewImage"
        />

        <!-- Preview Gambar -->
        <div v-if="previewUrl" class="mt-3 d-flex align-items-center">
            <img :src="previewUrl" alt="Preview Gambar" class="img-thumbnail mr-3" style="max-width: 200px;" />
            <b-button variant="danger" size="sm" @click="removeImage">Hapus Gambar</b-button>
        </div>
        </b-form-group>

        </div>

        <div class="form-wrapper-btn submit-btn-wrapper">
          <b-button type="submit" variant="pgiBtn">Kirim</b-button>
        </div>
      </b-form>
    </b-card>

    <ModalConfirm
      id="modal-confirm-input"
      title="Confirm Input Voucher"
      :isSubmitting="isSubmitting"
      desc="Apakah anda yakin untuk menginput voucher ini?"
      @submit="onSubmit"
    />
  </div>
</template>

<script>
export default {
  name: "input-voucher",
  data() {
    return {
      isSubmitting: false,
      input: {
        name: "",
        price: 0,
        expiryDay: 0,
        description: "",
        policy: "",
        discount: 0,
        maximum : 0,
        type: null,
        file: null
      },
      optionType: [
        { id: 1, name: "Diskon PGI" },
        { id: 2, name: "Undian PGI" },
        { id: 3, name: "External" }
      ],
      previewUrl: null,
    };
  },
  methods: {
      previewImage(event) {
    const file = event.target.files[0];
    if (file) {
      this.input.file = file;
      this.previewUrl = URL.createObjectURL(file);
    }
  },

  removeImage() {
    this.input.file = null;
    this.previewUrl = null;
  },
    openModalConfirm() {
      if (
        !this.input.name ||
        !this.input.price ||
        !this.input.expiryDay ||
        !this.input.type ||
        !this.input.description ||
        !this.input.policy ||
        !this.input.file
      ) {
        this.$helper.toastErr(this, "Harap lengkapi seluruh field termasuk upload gambar.");
        return;
      }
      if(this.input.type == 1){
        if(!this.input.discount || !this.input.maximum){
          this.$helper.toastErr(this, "Harap lengkapi seluruh field termasuk upload gambar.");
          return;
        }
      }

      this.$bvModal.show("modal-confirm-input");
    },

    async onSubmit() {
    this.isSubmitting = true;
    const formData = new FormData();

    // Buat objek data
    const dataObj = {
    name: this.input.name,
    price: this.input.price,
    expiryDay: this.input.expiryDay,
    description: this.input.description,
    policy: this.input.policy,
    type: this.input.type,
    };

    if (this.input.type === 1) {
    dataObj.discount = this.input.discount;
    dataObj.maximum = this.input.maximum;
    }

    // Append 'data' sebagai string JSON
    formData.append("data", JSON.stringify(dataObj));


  // Append file
  formData.append("file", this.input.file);

  try {
    const response = await this.$axios.post("voucher/", formData, {
      headers: { "Content-Type": "multipart/form-data" }
    });

    this.$helper.setFlash("Voucher baru telah berhasil dibuat!");
    this.$router.push(`/master/voucher`);
  } catch (error) {
    console.error(error);
    this.$helper.parseError(this, error);
  } finally {
    this.isSubmitting = false;
  }
    },
      formatRupiah(value) {
    if (!value) return '';
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

    },
    computed: {
    formattedMaximum: {
        get() {
        return this.formatRupiah(this.input.maximum);
        },
        set(value) {
        const rawValue = value.replace(/\./g, '').replace(/\D/g, '');
        this.input.maximum = Number(rawValue);
        }
    }
    }
};
</script>
